module.exports = __webpack_public_path__ + "img/img-4.f08c7754.png";